import * as React from 'react';
import { observer } from 'mobx-react-lite';
import { CustomRadioButtonWrapper, CustomRadioButtonWrapperProps, InputControls } from '../../components';
import { CustomFormItem } from '../../../custom_shared/components';
import { InputModelWithSource } from '../../models';
import { InputWithMeta } from '../../componentTypes';

// Please note that this is a generic component if behavior for your input is different - create a new independent component (like BusinessTypeInput.tsx etc.)

type Props = CustomRadioButtonWrapperProps & {
    input: InputModelWithSource;
    message?: string;
};

const GenericRadioButton: InputWithMeta<Props> = (props: Props) => {
    const { input, message, ...rest } = props;

    return (
        <CustomFormItem name={input.guid} message={message} isReadOnly={input.isReadOnly}>
            <CustomRadioButtonWrapper
                input={input}
                options={input.sourceProvider.options}
                topRightNode={<InputControls input={input} />}
                {...rest}
            />
        </CustomFormItem>
    );
};

GenericRadioButton.meta = {
    inputType: InputModelWithSource.name
};

export default observer(GenericRadioButton);
